<script>
import { mapState, mapActions } from 'vuex'
import VueApexCharts from 'vue-apexcharts'

export default {
   components: {
      VueApexCharts,
   },
   data() {
      return {
         loading: false,
      }
   },
   computed: {
      ...mapState({
         chartResponse: state => state.DashboardLkpmNonUmk.nonUmkChart,
         tahun: state => state.DashboardLkpmNonUmk.tahun,
         refreshTimestamp: state => state.DashboardLkpmNonUmk.refreshTimestamp,
         skin: state => state.appConfig.layout.skin,
      }),
      isDark() {
         return this.skin === 'dark'
      },
      chartSeries() {
         return [{
            name: 'Total',
            data: this.chartResponse.data.map(item => item.total),
         }]
      },
      chartOptions() {
         const textColor = this.isDark ? '#b4b7bd' : '#6e6b7b'

         return {
            chart: {
               type: 'bar',
               foreColor: textColor,
               toolbar: {
                  show: false,
               },
               fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
            },
            colors: ['#9f1e15'],
            plotOptions: {
               bar: {
                  borderRadius: 4,
                  columnWidth: '45%',
               },
            },
            dataLabels: {
               enabled: false,
            },
            grid: {
               borderColor: this.isDark ? '#3b4253' : '#ebe9f1',
               strokeDashArray: 4,
            },
            xaxis: {
               categories: this.chartResponse.data.map(item => item.nama),
               labels: {
                  style: {
                     colors: textColor,
                  },
               },
               title: {
                  text: 'Periode',
                  style: {
                     color: textColor,
                  },
               },
            },
            yaxis: {
               min: 0,
               forceNiceScale: true,
               title: {
                  text: 'Total',
                  style: {
                     color: textColor,
                  },
               },
               labels: {
                  style: {
                     colors: [textColor],
                  },
                  formatter: value => Math.round(value),
               },
            },
            tooltip: {
               theme: this.isDark ? 'dark' : 'light',
               y: {
                  formatter: value => `${value.toLocaleString('id-ID')}`,
               },
            },
         }
      },
   },
   watch: {
      tahun(newYear, oldYear) {
         if (newYear !== oldYear) this.loadData(newYear)
      },
      refreshTimestamp() {
         this.loadData(this.tahun)
      },
   },
   mounted() {
      this.loadData(this.tahun)
   },
   methods: {
      ...mapActions({
         getNonUmkChart: 'DashboardLkpmNonUmk/getNonUmkChart',
      }),
      async loadData(year) {
         this.loading = true
         try {
            await this.getNonUmkChart(year)
         } catch (error) {
            // Chart tetap menampilkan data kosong saat request gagal.
         } finally {
            this.loading = false
         }
      },
   },
}
</script>

<template>
   <b-overlay
      :show="loading"
      :variant="isDark ? 'dark' : 'white'"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
   >
      <b-row>
         <b-col cols="12">
            <b-card
               class="card-wrapper"
               :class="{ 'card-wrapper-dark': isDark }"
            >
               <div class="d-flex justify-content-between align-items-center mb-1">
                  <div>
                     <h4 class="mb-25">
                        LKPM Non UMK Tahun {{ tahun }}
                     </h4>
                     <small class="text-muted">Total Realisasi Non UMK berdasarkan periode triwulan</small>
                  </div>
               </div>
               <vue-apex-charts
                  type="bar"
                  height="350"
                  :options="chartOptions"
                  :series="chartSeries"
               />
            </b-card>
         </b-col>
      </b-row>
   </b-overlay>
</template>

<style scoped>
.card-wrapper {
   border: 0;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
   background-color: #ffffff;
}

.card-wrapper-dark {
   background-color: #283046;
   box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
}
</style>
